<template>
  <modelframe :message="message">
    <my-table
        :data="roleList"
        :count="roleList.length"
        :limit="-1"
        :column-set="columnSet"
    />
  </modelframe>
</template>

<script>
import myTable from "@/components/myTable";

export default {
  name: "roleManage",
  components:{myTable},
  data(){
    return {
      roleList:[],
      columnSet:[{columnName:'type',width:'180',label:'角色名称',sortable:false}],
      message:{
        code:0,
        msg:'',
      }
    }
  },
  methods:{
    setMessage(code,msg){
      this.message.code =code;
      this.message.msg =msg;
    },
    initData(data){//将后台数据初始化到userList中
      if(data){
        let dataObj = JSON.parse(data);
        let dataArray = Object.values(dataObj)[0];
        for (let i = 0; i < dataArray.length; i++) {
          this.roleList.push({type:dataArray[i]});
        }
      }else{
        this.roleList = ['管理员1','工程师1','代理商1','经销商1','客户1'];
      }

    }
  },
  created(){
    this.setMessage(1);//设置Loading
    this.axios.get('http://101.133.156.109:81/api/User/usertype').then((res)=>{
      let data = res.data
      if(data.status){
        this.initData(data.data);
        this.setMessage(0);
      }else{
        this.setMessage(-1,data.msg);
      }
    }).catch((error)=>{
      this.setMessage(-1,'请求数据失败,错误信息：'+error);
    });
  }
}
</script>

<style scoped>

</style>
